// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7315102a","453":"ad7309c3","455":"da067960"}[chunkId] + ".chunk.js";
};